import {
  ArticlesState,
  CLEAR_ARTICLE,
  SET_ARTICLE,
  SET_VOTE,
  ArticlesActionTypes,
} from './Types';

const initialState: ArticlesState = {
  article: undefined,
  loading: false,
  votes: {},
};

export function articlesReducer(state = initialState, action: ArticlesActionTypes): ArticlesState {
  switch (action.type) {
  case SET_ARTICLE:
    return {
      ...state,
      article: action.payload,
    };
  case CLEAR_ARTICLE:
    return {
      ...state,
      article: undefined,
    };
  case SET_VOTE:
    return {
      ...state,
      votes: {
        ...state.votes,
        [action.payload.id]: action.payload.vote,
      },
    };
  default:
    return state;
  }
}
